import React, { useState } from 'react';
import { Box, Button, Card, Typography } from "../utils/mui-imports";
import { SwiperSlide, Swiper } from "swiper/react";
import 'swiper/css';
import { Autoplay, EffectCards, EffectCoverflow, EffectCreative, EffectFlip, Thumbs } from "swiper/modules";
import { FaChevronDown, FaExpand } from "react-icons/fa";
import { motion } from 'framer-motion';
import { AutoAwesomeIcon } from '../utils/mui-imports';
import { useNavigate } from 'react-router-dom';
// Removed OptimizedImage - using native img for better performance

import { trackGAEvent } from '../utils/tracking';



const HeroBanner = ({ imageUrls, titles, scrollToBrowseLooks }) => {
  console.log("🎨 HeroBannerNewUI: Component starting to render");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const navigate = useNavigate();

  return (
    <div
      style={{
        height: 'auto',
        position: 'relative',
        justifyContent: 'center',
      }}
    >


<Box
        style={{
          position: 'absolute',
          top: '65%',
          width: '100%',
          display: 'flex',
          justifyItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '1rem',
          zIndex: 2,
          padding: '1rem',
          height: 'auto',
          
        }}
      >
         
      
          
          <Typography
            textTransform={'capitalize'}
            fontWeight={'bold'}
            variant="body1"
            color="white"
            fontSize={'0.85rem'}
            align='center'
            p={1}
          >
           From inspiration to creation, our AI turns your fashion instincts into fully-styled, shoppable looks in seconds. 
          </Typography>
        
      </Box>

      {/* "Curate Your Look" Button */}
      <Box
        style={{
          position: 'absolute',
          top: '80%',
          width: '100%',
          display: 'flex',
          justifyItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '1rem',
          zIndex: 2,
          padding: '1rem',
          height: 'auto',
        }}
      >
         
        <Button
          color="primary"
          sx={{
            backdropFilter: 'blur(5px)',
            borderRadius: 2,
            backgroundColor: 'rgba(1,1,1,0.85)',
            // border: '2px solid black',
          }}
          onClick={()=>{
            navigate("/curate-look");
            trackGAEvent('hero_create_look', {});
            
          }}
          startIcon={<AutoAwesomeIcon color='white' sx={{
            color:'white'
          }}/>}
          fullWidth
          variant="text"
        >
          
          <Typography
            textTransform={'capitalize'}
            fontWeight={'bold'}
            variant="body1"
            color="white"
            fontSize={'1rem'}
            p={1}
          >
Create a Look
          </Typography>
        </Button>
      </Box>

      {/* "Explore Looks" Button */}
      <Box
        style={{
          position: 'absolute',
          top: '90%',
          width: '100%',
          display: 'flex',
          justifyItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '1rem',
          zIndex: 2,
          padding: '1rem',
          height: 'auto',
        }}
      >
         
        <Button
          // color="primary"
          sx={{
            backdropFilter: 'blur(5px)',
            borderRadius: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            border: '1px solid rgba(1, 1, 1, 0.49)',
          }}
          // onClick={scrollToBrowseLooks}
          onClick={()=>{
            console.log("scrolling");
            scrollToBrowseLooks();
            trackGAEvent('hero_browse_looks', {});

          }}
          // startIcon={<FaExpand/>}
          endIcon={<FaChevronDown size={16} color='black' sx={{
            color:'black'
          }}/>}
          fullWidth
          variant="text"
        >
          
          <Typography
            textTransform={'capitalize'}
            fontWeight={'bold'}
            variant="body1"
            color="black"
            fontSize={'0.9rem'}
            // p={1}
          >
            Browse Looks
          </Typography>
        </Button>
      </Box>
    
     
    

      {/* Swiper Carousel - CRITICAL for LCP - Direct Import */}
      <Swiper
          modules={[EffectCards, Autoplay, EffectCreative, Thumbs]}
          direction="horizontal"
          grabCursor={true}
          thumbs={{ swiper: thumbsSwiper }}
          autoplay={{ delay: 2000,
            stopOnLastSlide:false
            
           }}
          //  effect={'creative'}
          //  creativeEffect={{
          //    prev: {
          //      shadow: true,
          //      translate: [0, 0, -400],
          //    },
          //    next: {
          //      translate: ['100%', 0, 0],
          //    },
          //  }}
          slidesPerView={1}
         
          onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
        >
          <Card>
            {imageUrls.map((url, index) => (
              <SwiperSlide key={index}>
                <Box
                  style={{
                    position: 'absolute',
                    top: '55%',
                    width: '100%',
                    display: 'flex',
                    justifyItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '1rem',
                    zIndex: 2,
                    padding: '1rem',
                    height: 'auto',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={index === currentIndex ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                      transition={{ duration: 0.5 }}
                    >
                      <Typography
                        variant="h2"
                        fontWeight="bold"
                        color="white"
                        align="center"
                      >
                        {titles[index]}
                      </Typography>
                    </motion.div>
                  </Box>
                </Box>
                <img
                  src={url}
                  alt={`Fashion ${index}`}
                  loading={index === 0 ? 'eager' : 'auto'}
                  fetchPriority={index === 0 ? 'high' : 'auto'}
                  style={{
                    width: '100%',
                    height: '100dvh',
                    // minHeight:'90vh',
                    objectFit: 'cover',
                    // borderBottomLeftRadius:24,
                    // borderBottomRightRadius:24,

                  }}
                />
              </SwiperSlide>
            ))}
          
          </Card>
        </Swiper>
    
    </div>
  );
};

export default HeroBanner;